import fetch from 'isomorphic-fetch';
import find from 'lodash/find';
import assign from 'lodash/assign';
import {
    SERVICE_URL,
    FETCH_DATA
} from '../config/player';
import { serialize, inIframe } from '../utils/ASVPUtils';


function parse (response) {
    let data = (response.data) ? response.data : response;

    if (data.stream && data.stream.assets) {
        data.stream.assets.map((asset) => {
            if (asset.mime_type === 'application/x-mpegURL' && asset.url.indexOf('adultswim-ott') === -1) {
                data.assetURL = asset.url;

                // always use pmd instead of ht
                data.assetURL = data.assetURL.replace('ht.cdn.turner.com', 'amd.cdn.turner.com');

                return;
            }
        });
    }

    // if no stream attached to video but does have segments and at least one of them
    if (!data.stream || !data.stream.assets || !data.stream.assets.length && data.segments && data.segments.length) {
        data.segments[0].assets.map((asset) => {
            if (asset.mime_type === 'application/x-mpegURL' && asset.url.indexOf('adultswim-ott') === -1) {
                data.assetURL = asset.url;

                // always use pmd instead of ht
                data.assetURL = data.assetURL.replace('ht.cdn.turner.com', 'amd.cdn.turner.com');

                // replace old turnerios url with new one
                data.assetURL = data.assetURL.replace('turnerios-f.akamaihd.net/i/adultswim/big', 'adultswim-vh.akamaihd.net/i');

                return;
            }
        });
    }

    data.poster = '';

    if (data.images && data.images.length) {
        var image = find(data.images, function(obj) { return obj.name === 'main'; });

        if (!image) image = find(data.images, function(obj) { return obj.name === 'legacy'; });

        if (image) data.poster = image.url;
    }

    if (data.stream && data.stream.assets) {
        data.stream.assets.map((asset) => {
            if (asset.mime_type === 'text/vtt') {
                data.vtt = asset.url;

                return;
            }
        });
    }

    return data;
}


export function fetchVideo (videoID) {
    // adds param if in an iframe
    var query = assign({}, FETCH_DATA, { iframe: inIframe() });

    query = serialize(query);

    return fetch(`${SERVICE_URL}${videoID}?${query}`)
        .then(response => response.json())
        .then(data => parse(data))
        .catch(err => console.error(err) );
}




// WEBPACK FOOTER //
// ./src/player/service.js